import {
  faqs,
  howItWorks,
  purchaseSeatsLanguages,
  createPerkTotalLabel,
  AnalyticsHeader,
} from "./helpers";
import {
  DefaultCheckoutTerms,
  DefaultRegistrationTerms,
} from "../../default_terms_and_conditions";
import { routes } from "@/global/routes";
import BackgroundImage from "public/images/aviators/aviators_bg.webp";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";
import BannerImage from "public/images/aviators/suite_banner_season_share.png";
import { TeamConfig } from "@/global/hooks/useTeamConfig";
import LogoImage from "public/images/aviators/aviators_logo_jan_24.png";
import SeatMap3dPreview from "public/images/aviators/aviators_seat_map_preview.png";

import suiteImage1 from "public/images/aviators/image1.jpg";
import suiteImage2 from "public/images/aviators/image2.jpg";
import suiteImage4 from "public/images/aviators/image4.jpg";
import suiteImage5 from "public/images/aviators/image5.jpg";
import suiteImage6 from "public/images/aviators/image6.jpg";
import suiteImage7 from "public/images/aviators/image7.jpg";
import suiteImage8 from "public/images/aviators/image8.jpeg";
import suiteImage10 from "public/images/aviators/menu.png";

import partySuiteMenuImage1 from "public/images/aviators/2026-Party-Suites-Menu-1.png";
import partySuiteMenuImage2 from "public/images/aviators/2026-Party-Suites-Menu-2.png";

const config: TeamConfig = {
  teamSchema: "aviators_suites",
  browserTitle: "Vegas Aviators",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Las Vegas Aviators",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-31086-baseball-sec",
    mapId: "blockmap2d",
    isView3dButtonHidden: false,
    suiteImages: {
      S1: [
        "https://suiteview.com/tour/aviators/360/?s=pano86900",
        "https://suiteview.com/tour/aviators/360/?s=pano86899",
        partySuiteMenuImage1.src,
        partySuiteMenuImage2.src,
      ],
      S2: [
        "https://suiteview.com/tour/aviators/360/?s=pano86906",
        "https://suiteview.com/tour/aviators/360/?s=pano86905",
        suiteImage4.src,
        partySuiteMenuImage1.src,
        partySuiteMenuImage2.src,
      ],
      S11: [
        "https://suiteview.com/tour/aviators/360/?s=pano86960",
        "https://suiteview.com/tour/aviators/360/?s=pano86959",
        suiteImage5.src,
        partySuiteMenuImage1.src,
        partySuiteMenuImage2.src,
      ],
      S12: [
        "https://suiteview.com/tour/aviators/360/?s=pano86966",
        "https://suiteview.com/tour/aviators/360/?s=pano86965",
        suiteImage1.src,
        suiteImage2.src,
        partySuiteMenuImage1.src,
        partySuiteMenuImage2.src,
      ],
      S20: [
        "https://suiteview.com/tour/aviators/360/?s=pano87014",
        "https://suiteview.com/tour/aviators/360/?s=pano87013",
        suiteImage8.src,
        partySuiteMenuImage1.src,
        partySuiteMenuImage2.src,
      ],
      S21: [
        "https://suiteview.com/tour/aviators/360/?s=pano87020",
        "https://suiteview.com/tour/aviators/360/?s=pano87019",
        suiteImage8.src,
        partySuiteMenuImage1.src,
        partySuiteMenuImage2.src,
      ],
      S22: [
        "https://suiteview.com/tour/aviators/360/?s=pano87026",
        "https://suiteview.com/tour/aviators/360/?s=pano87025",
        suiteImage8.src,
        partySuiteMenuImage1.src,
        partySuiteMenuImage2.src,
      ],
    },

    hide3dViewFromSlider: true,
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: false,
  inventoryType: inventoryTypeUIDs.suiteLevelV2,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    invPreviewAccountGroup: ["0"],
    isPerksEnabled: true,
    isCheckoutAdditionalDetailsEnabled: false,

    hidePreviewButtonIfNonAuthenticated: true,
  },

  oktaClientId: "",
  oktaIssuer: "",
  platform: vendorUUIDs.ticketmaster,
  refreshInventoryWhenEventClick: false,

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    AnalyticsHeader,
  },

  isSaveCardAllowed: true,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/aviatorslv/",

  // images
  images: {
    findGamesBannerImage: BannerImage.src,
    authBackgroundImage: BackgroundImage.src,
    checkoutStatusPageImage: BackgroundImage.src,
    giftCardStandalonePageImage: BannerImage.src,
    logoImage: LogoImage.src + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage.src,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    inventoryContainer: {
      emptyStateTitle: "No Suites Available.",
      emptyStateDesc: <>Try another game for suite availability.</>,
      getGridCellHeight: (arg) => (arg?.mdDown ? 240 : 190),
    },

    inventoryCardSettings: {
      isPBLineItemsVisible: true,
      isParkingPriceVisible: true,
      seatCountLabel: "Tickets Included",
      totalPriceLabel: "Ticket Price: ",
      inventorySuitePackageInfo: "Available as Add-On",
    },

    perks: {
      hideAddAllButton: true,
      images: {
        catering: [suiteImage6.src, suiteImage7.src, suiteImage10.src],
      },
      displayOnlyPrice: ["catering"],
    },
    checkoutPerkSubtotals: {
      perkTotalLabel: createPerkTotalLabel,
    },
  },

  colors: {
    primary: "#022243",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: null,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: purchaseSeatsLanguages,
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your Tickets Are Ready",
    checkoutSuccessDescription:
      "Click View Tickets to access your tickets now. A Las Vegas Aviators representative will be in contact with you shortly to confirm your reservation.",

    giftCard: {
      title: "Give The Gift Of Broadway",
      createGiftCard: {
        description:
          "Share the magic of Broadway with a friend or loved one. Upon purchase of a gift card, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift card is not refundable.",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Hippodrome Broadway Series shows in Baltimore.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Hippodrome Broadway Series shows in Baltimore.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
        },
        logout: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore.",
        },
        success: {
          description:
            "has been added to your Hippodrome Broadway Series in Baltimore Account Manager account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
